var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.883 77.06c18.25 0 33.043-14.794 33.043-33.043S62.132 10.975 43.883 10.975c-18.248 0-33.042 14.793-33.042 33.042 0 18.249 14.794 33.042 33.042 33.042z",
    fill: "#FFD6C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.007 70.776c14.763 0 26.731-11.968 26.731-26.73 0-14.764-11.968-26.732-26.73-26.732-14.764 0-26.732 11.968-26.732 26.731 0 14.763 11.968 26.731 26.731 26.731z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.356 31.02a26.721 26.721 0 11-9.893-10.077M76.926 43.997a33.057 33.057 0 11-6.435-19.602",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.926 26.373l13.49-1.418L70 11.465M61.08 44.433H43.867V22.636M43.866 65.89v-4.698M25.841 44.433h-3.736",
    stroke: "#2D2F33",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.866 49a4.568 4.568 0 100-9.135 4.568 4.568 0 000 9.135zM59.515 60.399a1.81 1.81 0 100-3.618 1.81 1.81 0 000 3.618zM28.218 32.02a1.81 1.81 0 100-3.62 1.81 1.81 0 000 3.62zM28.218 60.399a1.81 1.81 0 100-3.618 1.81 1.81 0 000 3.618z",
    fill: "#2D2F33"
  })));
}

export default SvgTimer;